import PubnubInappChat from './Pubnub';

// The main inbox is always PubNub. Supabase comms is reached only via the
// dedicated ops pages (/chat-v2, /chat-v2-cohort), never through here.
const InappChat = () => {
  return <PubnubInappChat />;
};

export default InappChat;
